const useConstantValueInvariant = (value, message) => {
};
export {
  useConstantValueInvariant
};
//# sourceMappingURL=useConstantValueInvariant.js.map
